module.exports = __webpack_public_path__ + "static/media/sembawang.8df2f037.png";